// Libraries
import { z } from 'zod';

export enum Environments {
  Local = 'local',
  Ephemeral = 'ephemeral',
  Test = 'test',
  Sandbox = 'sandbox',
  Staging = 'staging',
  Production = 'production',
}

const stages = Object.values(Environments);

type Stage = (typeof stages)[number];

function getStage(stage: string | undefined): Stage {
  if (!stage) return Environments.Production;

  if (stages.includes(stage as Stage)) {
    return stage as Stage;
  }
  return Environments.Production;
}

const stage = getStage(process.env.NEXT_PUBLIC_ENVIRONMENT);

function envToStr(value: string | undefined, defaultValue = '') {
  return value === undefined ? defaultValue : value;
}

const ConfigSchema = z.object({
  env: z.object({
    name: z.string(),
    versionTag: z.string(),
    isLocal: z.boolean(),
    isEphemeral: z.boolean(),
    isTest: z.boolean(),
    isSandbox: z.boolean(),
    isStaging: z.boolean(),
    isProduction: z.boolean(),
  }),
  services: z.object({
    apiGateway: z.string(),
    heimdallApi: z.string(),
    linersUi: z.string(),
  }),
  auth: z.object({
    url: z.string(),
    secret: z.string(),
  }),
  sessionExpireTime: z.string(),
});

export const config = ConfigSchema.parse({
  env: {
    name: stage,
    versionTag: envToStr(process.env.NEXT_PUBLIC_VERSION_TAG),
    isLocal: stage === Environments.Local,
    isEphemeral: stage === Environments.Ephemeral,
    isTest: stage === Environments.Test,
    isSandbox: stage === Environments.Sandbox,
    isStaging: stage === Environments.Staging,
    isProduction: stage === Environments.Production,
  },
  services: {
    apiGateway: envToStr(process.env.NEXT_PUBLIC_API_GATEWAY),
    heimdallApi: envToStr(process.env.NEXT_PUBLIC_HEIMDALL_API),
    linersUi: envToStr(process.env.NEXT_PUBLIC_LINERS_UI),
  },
  auth: {
    url: envToStr(process.env.NEXTAUTH_URL),
    secret: envToStr(process.env.NEXTAUTH_SECRET),
  },
  sessionExpireTime: envToStr(process.env.NEXT_PUBLIC_SESSION_EXPIRE_TIME),
});
